module.exports = __webpack_public_path__ + "static/img/weezie_icon.f2bd686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/weezie_icon.png
// module id = ./src/assets/logos/weezie_icon.png
// module chunks = 1